import React from "react";
import Slidebar from "../component/Slidebar";
import Translation from "utils/Translation";
import { Col, Row } from "react-bootstrap";

const Main = () => {
  return <>
  <div className="Home_Page">
    <h1 className="h1-page">
      <Translation tag={"Construction"}/>
    </h1>

  </div>
  
  
  </>;
};

export default Main;
